// Project.layout enumeration helpers.
//
// `layout` describes the project's PRIMARY default content. It splits into two
// families:
//   • Task layouts - the project holds tasks; layout selects the default view.
//   • Document layouts - the project holds documents; layout selects the
//     primary document type the project is built around.
//
// `changelog` is a document layout but a special case: instead of one primary
// document, the project renders a chronological feed of all changelog-type
// documents inside it. Hence the separate PRIMARY_DOC_LAYOUTS set, which
// excludes changelog so callers can decide whether to auto-create / auto-open
// a single primary document.

export const TASK_LAYOUTS = ['table', 'list', 'board', 'calendar', 'timeline', 'gallery'];

export const DOCUMENT_LAYOUTS = ['document', 'whiteboard', 'mindmap', 'embed', 'folder', 'changelog', 'database'];

// Document layouts that are backed by a single primary document the project
// auto-creates and opens on entry. Excludes 'changelog' (which is a feed).
// 'folder' is included - its primary document is the root folder, whose
// FolderView renders the project's nested document tree.
// 'database' is included - its primary document is a tabular Database whose
// DatabaseEditor renders the schema + rows.
export const PRIMARY_DOC_LAYOUTS = ['document', 'whiteboard', 'mindmap', 'embed', 'folder', 'database'];

export const isTaskLayout = (layout) => TASK_LAYOUTS.includes(layout);
export const isDocumentLayout = (layout) => DOCUMENT_LAYOUTS.includes(layout);
export const isPrimaryDocLayout = (layout) => PRIMARY_DOC_LAYOUTS.includes(layout);
export const isChangelogLayout = (layout) => layout === 'changelog';
